<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2-2">
<p class="centerImage"><img alt="image" src="images/img18.jpg" style="max-width: 100%"/></p>
<p class="caption"><em class="italic">Isabella de Fortibus was the last independent ruler of the Isle of Wight. From a stone carving in Christchurch, Hampshire.</em> <span class="smallcaps">The author</span> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 18_ch22.vue?1e97ada3